import { getSingleUIProps, parseServiceElements } from './dataModelerResources/index';
import { elementParser as actionElementParser } from './actionModelerResources/index';
/**
 * This is a representation of a data model
 */
// let data = {
//   schema: [],
//   UIElementd: formElement.getAttribute("id"),
//   dataName: "form" + formElement.getAttribute("id"),
//   attributeName: formElement.getAttribute("wabliname") || "",
//   buttons: [],
// };

//   actions: [],
/**
 *
 */
function getEntitiesTypeGroup(entities, type) {
  if (!entities) return [];
  return entities.filter((entity) => entity.getAttribute('annotationType') === type);
}

/**
 * Returns the html Elements with annotation name attribute
 * @param {Node} htmlElement
 * @return {NodeList}
 */
function getNamedElements(htmlElement) {
  return [...htmlElement.querySelectorAll('[annotationName]')].filter(
    (element) =>
      element.getAttribute('annotationName') && element.getAttribute('annotationName') !== '-1'
  );
}
/**
 * Returns the html Elements with annotation link attribute
 * @param {Node} htmlElement
 * @return {Array}
 */
function getAnnotatedNames(htmlElement) {
  return [...htmlElement.querySelectorAll('[annotationName]')].map((element) =>
    element.getAttribute('annotationName')
  );
}

/**
 *  Return a Map consting of named Elements as keys and element that link to
 *  them as values.
 */
function getMapOfEntitiesToLinks(linked) {
  const mapOfEntities = new Map();
  linked.forEach((item) => {
    const annotationLink = item.getAttribute('annotationLink');
    if (mapOfEntities.has(annotationLink)) mapOfEntities.get(annotationLink).push(item);
    else mapOfEntities.set(annotationLink, [item]);
  });
  return mapOfEntities;
}

function parseSingleSchemaEntry(groupElement) {
  const schemaEntry = {
    entryName: groupElement?.getAttribute('annotationName') || 'noname',
    entryType: groupElement?.getAttribute('attributeType') || 'not defined',
    table: groupElement?.getAttribute('annotationTable') || false,
    UIProps: getSingleUIProps(groupElement)
  };
  if (groupElement?.getAttribute('attributeType') === 'entity')
    schemaEntry.entityName = groupElement?.getAttribute('customAttributeType') || 'not defined';
  return schemaEntry;
}

function parseMultySchemaEntry(groupElements) {
  const schemaEntry = {
    entryName: groupElements[0]?.getAttribute('annotationName') || 'noname',
    entryType: groupElements[0]?.getAttribute('attributeType') || 'not defined',
    table: false,
    values: groupElements[0].getAttribute('annotationValue') || [],
    UIProps: groupElements.reduce((acc, element) => getSingleUIProps(element), [])
  };
  return schemaEntry;
}

function extractSchemas(arraysOfElements) {
  let schemas = [];
  arraysOfElements.forEach((array) => {
    const elements = [...array];
    const elementsLeft = new Set(elements);

    const elementCheckbox = elements.filter(
      (element) => element.getAttribute('attributeType') === 'checkbox'
    );
    if (elementCheckbox.length > 0) schemas.push(parseMultySchemaEntry(elementCheckbox));
    elementCheckbox.forEach((element) => {
      elementsLeft.delete(element);
    });

    const elementRadiobox = elements.filter(
      (element) => element.getAttribute('attributeType') === 'radiobox'
    );
    if (elementRadiobox.length > 0) schemas.push(parseMultySchemaEntry(elementRadiobox));
    elementRadiobox.forEach((element) => {
      elementsLeft.delete(element);
    });
    schemas = schemas.concat([...elementsLeft].map((element) => parseSingleSchemaEntry(element)));
  });

  return schemas;
}

function parseSingleCategory(entities, link) {
  const mapAttributeElements = new Map();
  getEntitiesTypeGroup(entities, 'attribute').forEach((entity) => {
    if (mapAttributeElements.has(entity.getAttribute('annotationName')))
      mapAttributeElements.get(entity.getAttribute('annotationName')).push(entity);
    else mapAttributeElements.set(entity.getAttribute('annotationName'), [entity]);
  });

  const dataModel = {
    schema: (entities && extractSchemas([...mapAttributeElements.values()])) || [],
    dataName: link || '',
    attributeName: link || '',
    UIElementd: {},
    buttons: [],
    actions:
      (entities &&
        getEntitiesTypeGroup(entities, 'method').map((entity) => actionElementParser(entity))) ||
      []
  };
  return dataModel;
}

/**
 *
 * @param {NodeList} categories the list of nodes with category attribute
 * @return {Map} mapOfDataGroups a Map of pairs: [key:Node, values:Nodelist]
 */
function getCategoryNodeGroups(categories) {
  const mapOfDataGroups = new Map();
  categories.forEach((category) => {
    mapOfDataGroups.set(category, category.querySelectorAll('[annotationName]'));
  });

  return mapOfDataGroups;
}

/**
 * TODO this will need a change of dataModel
 */
function createDataModel(htmlElement, annotations) {

  let dataModel = [];
  if (!htmlElement) return dataModel;
  // this is not working and should be fixed (!(htmlElement instanceof Node)) return dataModel;
  // const categoryList = htmlElement.querySelectorAll('[wablicategory]');

  const namedElementArray = getNamedElements(htmlElement);
  const annotationNameArray = getAnnotatedNames(htmlElement);
  const annotationNamesMap = namedElementArray.reduce(
    (acc, current) => acc.set(current.getAttribute('annotationname'), current),
    new Map()
  );

  if (!annotationNameArray.length) return dataModel;

  const annotationsEntities = annotations.combinations
    .filter((combination) => annotationNameArray.includes(combination.annotationName))
    .map((combination) => {
      const entry = {
        ...combination,
        ...annotationNamesMap
          .get(combination.annotationName)
          .getAttributeNames()
          .reduce((acc, curr) => {
            acc[curr] = annotationNamesMap.get(combination.annotationName).getAttribute(curr);
            return acc;
          }, {}),
        getAttribute(field) {
          return this[field];
        }
      };

      if (combination.attributeType === 'radiobox' || combination.attributeType === 'checkbox')
        entry.annotationValue = namedElementArray
          .filter(
            (element) => element.getAttribute('annotationName') === combination.annotationName
          )
          .map((element) => element.getAttribute('annotationValue'));

      return entry;
    });

  const mapAnnotatedEntities = getMapOfEntitiesToLinks(annotationsEntities);

  dataModel = [...mapAnnotatedEntities].map(([link, entities]) =>
    parseSingleCategory(entities, link)
  );


  return dataModel;
}

function createServiceModel(htmlElement) {
  let serviceModel = [];
  if (!htmlElement) return serviceModel;

  const arrayOfServices = [...htmlElement.querySelectorAll('[wabli-service-id]')];
  try {
    serviceModel = arrayOfServices.map((service) => parseServiceElements(service));
  } catch (e) {
    serviceModel = [];
  }

  return serviceModel;
}

export {
  createDataModel,
  getCategoryNodeGroups,
  parseSingleCategory,
  getAnnotatedNames,
  getMapOfEntitiesToLinks,
  getEntitiesTypeGroup,
  getNamedElements,
  createServiceModel
};
